export default __webpack_public_path__ + "static/media/deardiary.09de52ac.png";